//30분 단위 시간 끊기
export const MinuteRound = (date = new Date()): Date => {
  const minute = 30
  const ms = 1000 * 60 * minute

  return new Date(Math.ceil(date.getTime() / ms) * ms)
}
